import classNames from 'classnames';
import styles from './checkbox-group-heading.module.scss';

const CheckboxGroupHeading = ({
	name,
	count = 0,
	standalone = false,
}: {
	name: string;
	count: number;
	// a group that is not inside a CollapsibleDrawer has to carry the divider and
	// the heading weight itself, or it reads as body copy next to the drawers
	standalone?: boolean;
}) => {
	return (
		<div
			className={classNames(styles.checkboxGroupHeading, {
				[styles.standalone]: standalone,
			})}
		>
			{name}
			{count > 0 && (
				<div className={styles.filterCount} data-testid="filter-count">
					{count}
				</div>
			)}
		</div>
	);
};

export default CheckboxGroupHeading;
